import React from 'react';
import PropTypes from 'prop-types';

import CommentField from './CommentField';
import ResourceDoesNotExist from './ResourceDoesNotExist';

import utils from './utils';
import { toast } from '../toast';

class PostCommentField extends React.Component {
    submit = () => {
        if (this.commentField.isProcessing() ||
            this.commentField.hasError() ||
            this.commentField.isEmpty) return Promise.reject();

        const mentions = utils.getMentions(this.commentField.getContent());

        return this.props.commentsStore
            .checkMentionPermissionsAndAlert(mentions)
            .then(() => {
                this.commentField.setProcessing(true);
                this.props.commentsStore.api
                    .submitComment(this.props.commentsStore.resource,
                        this.commentField.getContent(),
                        mentions)
                    .then(comment => {
                        this.clearComment();
                        !this.props.commentsStore.getComment(comment.id) &&
                            this.props.commentsStore.add(comment);
                        this.commentField.setProcessing(false);
                    })
                    .catch(err => {
                        toast('ERROR_OCCURED');
                        this.commentField.setProcessing(false);
                    });
            });
    };

    clearComment = () => this.commentField.clear();

    renderCommentActions = () =>
        (<span className='comment-actions'>
            <a
                className={`comment-action-btn ${this.commentField.hasError() ? 'disabled' : ''}`}
                onClick={this.submit}
                ga-action={this.props.commentsStore.GASettings.action}
                ga-label='New_Comment'
                data-what='comment-action'
                data-which='comment-post'
            >{ gettext('Post') }</a>
            <a
                className='comment-action-btn'
                onClick={this.clearComment}
                ga-action={this.props.commentsStore.GASettings.action}
                ga-label='Cancel_New_Comment'
                data-what='comment-action'
                data-which='comment-cancel'
            >{ gettext('Cancel') }</a>
        </span>);

    render () {
        return this.props.commentsStore.resource.exists
            ? <div className='post-comment-wrapper' data-what='post-comment-field'>
                <CommentField
                    ref={commentField => { this.commentField = commentField; }}
                    placeholder={ gettext('Click here to enter a comment. @Mention someone to notify them.') }
                    onEnter={this.submit}
                    onEscape={this.clearComment}
                    childrenFunc={this.renderCommentActions}
                    commentsStore={this.props.commentsStore}
                />
            </div>
            : <ResourceDoesNotExist/>;
    }
}

export default PostCommentField;

PostCommentField.propTypes = {
    commentsStore: PropTypes.object.isRequired
};
